import type { LoginType } from '@/constants/account'
import type { SellInfo } from '@/typings/subscribe'

export interface LoginParams {
  loginType: LoginType
  passwd?: {
    username: string
    password: string
  }
  sms?: CaptchaSmsParams
  wechat_qrcode?: {
    code: string
    key: string
    token: string
  },
  discord?: {
    code: string
    state: string
    redirect_uri: string
  }
  google?: {
    access_token: string
  }
  version?: number
}

export interface Captcha {
  key: string
  value: string
}

export interface CaptchaSmsParams {
  countryCode: string
  phone: string
  // captcha: Captcha
}

export interface RegisterParams extends CaptchaSmsParams {
  password: string
}

export interface WeChatQrcode {
  code: string
  key: string
  token: string
  qrcode: string
  expireAt: number
  expireTime: number
}

export interface MemberInfo {
  userId: number
  userMember: {
    id: number
    member: SellInfo
    status: number
    expireAt: number
    renew: MemberRenewStatus
  } | null
  status: number
}

export interface RemainingBalance {
  usage: {
    task: number
    upscale: number
    realtime: number
  }
  limit: {
    task: {
      limit: number
      period: number
    }
    upscale: {
      limit: number
      period: number
    }
    realtime: {
      limit: number
      period: number
    }
  }
}

export enum MemberRenewStatus {
  NONE,
  CANCEL,
  AUTO
}

export interface InvitationCodeInfo {
  code: string
  count: number
  invitedCount: number
  rewardDuration: number
  rewardAmount: number
}

/**
 *  账户会员状态
 */
export enum MemberStatus {
  ONE_DAY = 'oneDay',
  EXPIRED = 'expired',
  NORMAL = 'normal'
}

/**
 * 头像类型
 */
export enum AvatarType {
  /**
   * 上传图片
   */
  UPLOAD = 1,
  /**
   * 丑头像
   */
  UGLY = 2,
  /**
   * 好看
   */
  COLOR = 3
}

export interface AdTags {
  fb: {
    fbp: string
    fbc: string
  }
}

/**
 * 点数
 */
export interface UserCredits {
  total_balance: number   //总余额
  balance_by_type:{
    campaign: number      //bonus点数
    daily:number          //每日点数
    monthly:number        //月度订阅点数
    recharge:number       //充值点数
  }
  details:{
    credits_type:string //点数类型
    amount:number       //数量
    expired_at:number   //过期时间
  }
}